<!--
 * @description: 问诊距离限制
 * @fileName: index.vue
 * @author: WePunk
 * @date: 2024-06-13 10:40:24
!-->
<template>
    <div>
        <!-- navbar -->
        <van-nav-bar class="first-bar" :title="title" :border="false" left-arrow fixed @click-left="onClickLeft" />

        <div class="content">
            <div class="block-box position">
                <div class="flex">
                    <div class="title"> 门店位置 </div>
                    <div class="setting" @click="setPosition"> {{setText}}<van-icon name="arrow" /> </div>
                </div>
                <div class="map-container">
                    <div class="map-bg">
                        <div id="container" class="address"> </div>
                    </div>
                    <div v-show="!address" class="click-tips" @click="setPosition">
                        <van-icon size="16" color="#00B955" name="location" />
                        点击选择门店所在位置
                    </div>
                </div>
                <div v-if="address" class="address-desc">
                    <van-icon size="16" color="#999999" name="location" />
                    {{ address }}
                </div>
            </div>

            <div class="block-box">
                <div class="flex">
                    <div class="title"> 限制离店使用 </div>
                    <van-switch active-color="#00B955" inactive-color="#B9B9B9" size="22px" :value="checked"
                        @input="onUpdateCheck" />
                </div>
                <div class="tips">开启后，小程序扫码问诊将限制在本店使用</div>
            </div>
            <div class="block-box">
                <div class="flex">
                    <div class="title"> 授权定位 </div>
                    <div v-if="!isAuthLoa" class="auth-t no-auth" @click="toAuthHandel">未授权</div>
                    <div v-else class="auth-t">已授权</div>
                </div>
                <div class="tips">更具您的位置信息，提供对应药店的问诊服务</div>
            </div>
            <div class="block-box bg-none">
                <div class="title"> 如何进行权限设置? </div>
                <div class="tips">
                    <p>
                        如要开启或关闭权限授予，请按照以下步骤操作：<br>
                        1.打开手机设置<br>
                        2.在应用列表内找到应用<br>
                        3.点击进入，查看或修改权限设置<br>
                    </p>
                </div>
            </div>
        </div>

        <van-dialog className="dialog-box" v-model:show="dialogShow" :showConfirmButton="false">
            <div class="title">获取当前位置信息</div>
            <div class="context">需要获取您的定位权限，以便限制扫码问诊仅在本店使用</div>
            <div class="btns flex">
                <div class="cancel" @click="dialogShow = false">取消</div>
                <div class="confirm" @click="toAuthHandel">去授权</div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { loadBaiDuMap } from "@/utils/baiduMapGL"
import { Switch, Toast  } from "vant"
import pointIcon from "../../icons/pos-location.png"
import { disLimitGet, disLimitUpdate } from "@/api"
import { getCookie } from '@/utils/auth'
import { getIOSVersion } from '@/utils/index'
import Cookies from "js-cookie"

export default {
    components: {
        "van-switch": Switch
    },
    data() {
        return {
            title: '问诊离店限制',
            checked: false,
            dialogShow: false,
            isAuthLoa: false,
            address: "",
            pos: { lng: null, lat: null }, // 后台API传入的定位
            devicePos: {},  // 当前设备的GSP定位
            BMapGL: null,
            map: null,
            webkit: null,
        }
    },
    // beforeCreate(){
    //     // 本地测试Cookie，发布时需要去掉
    //     const cookies = `native_client=android;native_token=8726acad40abc947f0978ee7b7108f3d;native_version=3.2.1;native_organSign=LZA00108457;native_drugstoreName=墨玉测试江北区大药房;native_accountId=1461325437010690048;native_deviceUuid=150f5d13-d036-40a5-9404-c563a6bcf478;native_loginName=17600000005;storeId=LZA00108457;native_type=4;native_source=1;native_user_id=1461325437010690048;native_account_id=1461325437010690048;native_poi_id=12573;native_support_tim=1;uid=CgoUFGZoDVSgTaafSZocAg==;crosSdkDT2019DeviceId=wvugks-czbi9u-szf3vmi4fceaimw-glq3kdlgd;pageId=LZA00108457_98462_2024-06-11%2016:39:48`
    //     const str = cookies.split(';')
    //     for(let i = 0; i < str.length; i++){
    //         const [key,value] = str[i].split('=')
    //         if(key && value) Cookies.set(key.trim(), value.trim())
    //     }
    // },
    created() {
        console.log('UA',navigator.userAgent)
        // 安卓授权回调
        window.locationSuc = (lng, lat, address) => {
            console.log('授权成功：', lng, lat, address, typeof lng)
            this.isAuthLoa = true
            if (lng && lat) {
                // 当前设备的经纬度
                this.devicePos = { lng, lat, address }
                if(!this.pos.lng) this.pos = { lng, lat }
                Toast.clear()
            }
            setTimeout(Toast.clear, 5000)
        }
        window.locationFail = (err) => {
            console.log('获取定位失败：', err)
            this.isAuthLoa = false
        }
        window.locationErr = (status) => {
            this.isAuthLoa = false
            if(status){
                this.showToast('请检查是否开启定位权限', ()=>{
                    // window.AndroidInterface.openAppSettings()
                })
            }
        }
        
        window.getLocationStatus = (status = false)=>{
            console.log('获取授权状态：', status)
            if(status){
                console.log('调用定位信息')
                // 如果授权成功，去获取定位经纬度
                Toast.loading({ duration: 0, forbidClick: true, message: '加载中...'  })
                window.AndroidInterface.getAddressLngLat();
            }
            this.isAuthLoa = !!status
        }
        this.initMap();

    },
    mounted() {

        if(window.AndroidInterface){
            console.log("调用安卓授权：",window.AndroidInterface)
            window.AndroidInterface.getAuthStatus();
        }else if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sdkTracker){
            console.log("调用ios授权")
            this.webkit = window.webkit.messageHandlers.sdkTracker;
            this.webkit.postMessage({ type:'track', name: 'getAuthStatus' })
        }

        this.getDistanceLimit();
    },
    computed:{
        setText(){return this.address ? '修改' : '去设置'}
    },
    methods: {
        showToast(message, callback){
            const toast = {  message,  className:'limit-toast'  }
            if(callback){ toast.onClose = callback }
           return Toast(toast)
        },
        async initMap() {
            const BMapGL = await loadBaiDuMap().catch(e=>{
                console.log('地图加载失败：', e)
            });
            const map = new BMapGL.Map('container'); // 创建Map实例
            const center = { lng: this.pos.lng || 116.404, lat: this.pos.lat || 39.915 }
            const point = new BMapGL.Point(center.lng, center.lat); // 创建点坐标
            map.centerAndZoom(point, 16);
            map.enableScrollWheelZoom(); // 启
            this.BMapGL = BMapGL;
            this.map = map;
            this.address && this.setPoint(center)
        },

        // 获取接口限制信息
        async getDistanceLimit() {
            const ret = await disLimitGet({
                organSign: getCookie('native_organSign'),
            }).catch(err => {
                console.log("接口请求失败", err)
            });
            const { data } = ret
            if (data.result) {
                const { distanceLimitSwitch, latitude, longitude, mapLocationAddress = "" } = data.result
                this.pos.lng = longitude;
                this.pos.lat = latitude;
                this.address = mapLocationAddress;
                this.checked = !!distanceLimitSwitch;
            }
            this.initMap()
        },
        toAuthHandel() {
            // 调用原生方法
            if(window.AndroidInterface){
                Toast.loading({ duration: 0, forbidClick: true, message: '加载中...'  })
                window.AndroidInterface.showAuthToast('授权');
            }else if(this.webkit){
                // 去系统设置页面
                this.webkit.postMessage({ type:'track', name: 'showAuthToast' })
            }else {
                console.log('没有移动端接口信息')
                this.showToast('授权失败，请手动开启定位')
            }
            this.dialogShow = false;
        },
        async onUpdateCheck(checked) {
            if(!getCookie('native_organSign'))return; 
            if (this.address) {
                this.checked = checked
                // 更新店铺限制
                const ret = await disLimitUpdate({
                    distanceLimitSwitch: Number(checked),
                    organSign: getCookie('native_organSign'),
                })
                ret.data.result &&  this.showToast('设置成功')
            } else {
                this.showToast('请先添加门店信息')
            }
        },

        setPoint(pos) {
            const posIcon = new this.BMapGL.Icon(pointIcon, new BMapGL.Size(30, 60));
            const point = new this.BMapGL.Point(pos.lng, pos.lat);
            const marker = new this.BMapGL.Marker(point, { icon: posIcon });        // 创建标注
            marker.setOffset(new this.BMapGL.Size(0, -20));
            this.map.clearOverlays()
            this.map.addOverlay(marker)
            this.map.centerAndZoom(point, 18)
        },
        /**
         * @description: 点击左侧按钮
         */
        onClickLeft() {
            window.location.href = 'protocol://action/finish/'
        },

        // 去设置定位
        setPosition() {
            // 获取当前系统定位，如未授权弹出去授权窗
            if (!this.isAuthLoa) return this.dialogShow = true;
            // 如已授权，去设置页面
            const verison = getIOSVersion();
            // verison.majorVersion < 14
            if(verison){
                window.location.href = window.location.origin  +
                `/patient/distanceLimit/storeMap?lng=${this.devicePos.lng}&lat=${this.devicePos.lat}&address=${this.devicePos.address}`
            }else{
                this.$router.push({ path: `/distanceLimit/storeMap`, query: this.devicePos })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.limit-toast{
    width: fit-content!important;
    min-width: 10px;
}
</style>

<style scoped lang="scss">
.first-bar{
    z-index: 20;
}
.content {
    background-color: #F7F7F7;
    padding-top: 1rem;
    min-height: 100vh;
    box-sizing: border-box;
    font-size: 16px;
}

.flex {
    font-family: PingFangSC-Medium;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

.auth-t,
.tips {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
}

.auth-t {
    font-size: 16px;

    &.no-auth {
        color: #F65455;
    }
}

.block-box {
    margin-top: 10px;
    padding: 16px;
    background-color: #fff;
}

.address-desc {
    padding-top: 5px;
    font-size: 14px;
    color: #999999;
}

.position {
    margin-top: 18px;

    .setting {
        font-family: PingFangSC-Regular;
        color: #999999;
    }

    .address {
        height: 160px;
        width: 100%;
        background-color: #F7F7F7;
        border-radius: 10px;
    }
}

.map-container {
    position: relative;

    .map-bg{
        height: 120px;
        overflow: hidden;
        background-color: #F7F7F7;
        border-radius: 10px;
        box-shadow: 0px 0px 10px #f2f2f2;
    }

    .click-tips {
        position: absolute;
        top: 50%;
        left: 50%;
        padding: 10px 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        white-space: nowrap;
        transform: translate(-50%, -50%);
        z-index: 12;
        background: #fff;
        box-shadow: 0 0 10px 0 #51515147;
        border-radius: 25px;
    }
}

.bg-none {
    padding-top: 0px;
    color: #484A56;
    background-color: transparent;
    font-size: 12px;

    .title {
        margin-bottom: 4px;
    }

    p {
        font-size: 12px;
    }
}

.dialog-box {
    border-radius: 7px;
    text-align: center;
    color: #41435D;

    .title {
        font-family: PingFangSC-Medium;
        padding: 20px 0;
        color: #111734;
        font-weight: 600;
        font-size: 18px;
    }

    .context {
        max-width: 240px;
        margin: 0 auto;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 15px;
    }

    .btns {
        border-top: 1px solid #eee;
        margin-top: 20px;

        .cancel {
            width: 50%;
            padding: 10px 0;
            border-right: 1px solid #eee;
        }

        .confirm {
            width: 50%;
            padding: 10px 0;
            color: #00B955;
        }
    }
}
</style>
